<template>
  <PartnersList />
</template>

<script>
import PartnersList from '@/components/content/partners/AllPartners.vue'

export default {
  name: 'ContentPartners',
  components: { PartnersList }
}
</script>

<style scoped>

</style>
